import { useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import Select from 'react-select';
import useDataBean from '../../../../../core/services/dataBean/useDataBean';
import { _ErrorDetails, _QualityErrorDetails, _QualityErrorTypes, _SeverityLevels } from '../../../../../core/services/dataBean/EntityCatalog';

interface Props {
    idErrorType?: number;
    idSelector: number;
    onChange: any;
    label?: string;
    returnType?: "ID" | "Object";
}

export const SelectQualityErrorDetails = ({ idSelector, onChange, label, returnType = "ID", idErrorType }: Props) => {
    const { instance, bean, setBean, lista, setLista } = useDataBean(_QualityErrorDetails);
    const [selectedOption, setSelectedOption] = useState<any>(null);

    useEffect(() => {
        getLista();
    }, [idErrorType]);

    useEffect(() => {
        if (idSelector && lista.length > 0) {
            const found = lista.find(item => item.DataBeanProperties.IDQualityErrorDetails === idSelector);
            if (found) {
                setSelectedOption({
                    value: found.DataBeanProperties.IDQualityErrorDetails,
                    label: `${found.DataBeanProperties.CodeError} - ${found.DataBeanProperties.Name}`,
                    item: found
                });
            }
        }
    }, [idSelector, lista]);

    const getLista = () => {
        const props: any = {
            State: 1,
        }
        if (idErrorType) props.IDQualityErrorTypes = idErrorType;
        instance.getQualityErrorDetailsCatalogPorPropiedades(props, null).then(
            (resp: any) => {
                if (resp) setLista(resp);
            }).catch(err => toast.error(err));
    };

    const handleChange = (option: any) => {
        setSelectedOption(option);
        if (!option) {
            if (onChange)
                onChange(returnType === "Object" ? {} : null);
        } else {

            if (onChange) {
                onChange(returnType === "Object" ? option.item.DataBeanProperties : option.value);
            }
        }
    };

    const options = lista.map((item: any) => ({
        value: item.DataBeanProperties.IDQualityErrorDetails,
        label: `${item.DataBeanProperties.CodeError} - ${item.DataBeanProperties.Name}`,
        item: item
    }));

    return (
        <div>
            {label && label != " " &&
                < label > {label ?? "Error - Calidad"}</label>
            }
            <Select
                options={options}
                value={selectedOption}
                onChange={handleChange}
                isClearable
                placeholder="Selecciona un error..."
                noOptionsMessage={() => "Sin coincidencias"}
            />
        </div >
    );
};
